import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Upload,
  Dropdown,
  Menu,
  Select,
  Card,
  Form
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { FileService } from "../../services/file/FileService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./PromptsTable.css";
import { showSuccessToast } from "../general/ToastHelper";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { CfgOneStepService } from "../../services/cfgOneStep/CfgOneStepService";

const { Option } = Select;

class OneStepCallFlow extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("oneStepCallFlowConfig");
    this.fileService = new FileService();
    this.groupService = new AccountGroupService();
    this.cfgOneStep = new CfgOneStepService();

    this.state = {
      isFetching: false,
      groups: [],
      loading: false,
      inboundGroups: [],
      agentGroups: [],
      prompts: [],
      cfgOneStep: {},
      formChanged: false,
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let [prompts, groups, cfgOneStep] = await Promise.all([
        this.getAllPrompts(),
        this.getAllGroups(),
        this.getCfgOneStep(),
      ]);

      let agentGroups = groups.ivrList.filter(
        (item) => item.groupType === "SXG"
      );
      let inboundGroups = groups.ivrList.filter(
        (item) => item.groupType === "IBG"
      );

      this.setState({
        prompts: prompts.ivrList,
        agentGroups: agentGroups,
        inboundGroups: inboundGroups,
        isFetching: false,
        cfgOneStep: cfgOneStep.ivrCustomEntityObject,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllPrompts() {
    try {
      let data = await this.fileService.getPromptsService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getCfgOneStep() {
    try {
      let data = await this.cfgOneStep.getCfgOneStep(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllGroups() {
    try {
      let data = await this.groupService.getAccountGroups(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  handleDropdownChange = (e) => {
    this.setState({
      formChanged: true,
    });
  };

  handleConfirm = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          let record = {
            accountId: this.props.context.user.accountId,
            ibgGroupId: values.ibgGroupId,
            sxgGroupId: values.sxgGroupId,
            welcomePrompt: values.welcomePrompt,
            waitingPrompt: values.waitingPrompt,
          };
          let data = await this.cfgOneStep.createCfgOneStep(
            this.props.context.session_id,
            record
          );
          this.componentDidMount();
          showSuccessToast("Saved successfully");
        }
        this.setState({ loading: false, formChanged: false });
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    });
  };
  handleDeactivate = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          let record = {
            accountId: this.props.context.user.accountId,
            ibgGroupId: values.ibgGroupId,
            sxgGroupId: values.sxgGroupId,
            welcomePrompt: values.welcomePrompt,
            waitingPrompt: values.waitingPrompt,
            status: "DEACT",
          };
          let data = await this.cfgOneStep.editCfgOneStep(
            this.props.context.session_id,
            record
          );
          this.componentDidMount();
          showSuccessToast("Deactivated successfully");
        }
        this.setState({ loading: false });
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    });
  };

  render() {
    let { isFetching, prompts, agentGroups, inboundGroups } = this.state;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const { getFieldDecorator } = this.props.form;
    const promptOptions = prompts.map((opt) => (
      <Option key={opt.fileId} value={opt.name}>
        {opt.name}
      </Option>
    ));
    const agentGroupOptions = agentGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));

    const inboundGroupOptions = inboundGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));
    return (
      <Page title={"One Step CallFlow"}>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <Card
            style={{
              marginTop: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
            bordered={false}
          >
            {this.state.cfgOneStep.status == "ACT" ? (
              <h3
                style={
                  this.props.context.curr_dir === "ltr"
                    ? {
                        float: "right",
                        marginRight: " 30px",
                        marginTop: "14px",
                        color: "green",
                        fontWeight: "600",
                      }
                    : {
                        float: "left",
                        marginLeft: " 30px",
                        marginTop: "14px",
                        color: "green",
                        fontWeight: "600",
                      }
                }
              >
                <Icon
                  type="check"
                  style={
                    this.props.context.curr_dir === "ltr"
                      ? { marginRight: "5px" }
                      : { marginLeft: "5px" }
                  }
                />
                Activated{" "}
              </h3>
            ) : (
              <h3
                style={
                  this.props.context.curr_dir === "ltr"
                    ? {
                        float: "right",
                        marginRight: " 30px",
                        marginTop: "14px",
                        color: "red",
                        fontWeight: "600",
                      }
                    : {
                        float: "left",
                        marginLeft: " 30px",
                        marginTop: "14px",
                        color: "red",
                        fontWeight: "600",
                      }
                }
              >
                <Icon
                  type="stop"
                  style={
                    this.props.context.curr_dir === "lrt"
                      ? { marginRight: "5px" }
                      : { marginLeft: "5px" }
                  }
                />
                Deactivated{" "}
              </h3>
            )}
            <Form className="form-style" {...formItemLayout}>
              <Form.Item label="Welcome Message" {...formItemLayout}>
                {getFieldDecorator("welcomePrompt", {
                  initialValue: this.state.cfgOneStep.welcomePrompt,

                  rules: [
                    {
                      required: true,
                      message: "Please select welcome message",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    onChange={(value) => this.handleDropdownChange(value)}
                  >
                    {promptOptions}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="Waiting Message" {...formItemLayout}>
                {getFieldDecorator("waitingPrompt", {
                  initialValue: this.state.cfgOneStep.waitingPrompt,

                  rules: [
                    {
                      required: true,
                      message: "Please select waiting message",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    onChange={(value) => this.handleDropdownChange(value)}
                  >
                    {promptOptions}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="Agent Group Name" {...formItemLayout}>
                {getFieldDecorator("sxgGroupId", {
                  initialValue: this.state.cfgOneStep.sxgGroupId,
                  rules: [
                    {
                      required: true,
                      message: "Please select Agent Group",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    onChange={(value) => this.handleDropdownChange(value)}
                  >
                    {agentGroupOptions}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="Inbound Group Name" {...formItemLayout}>
                {getFieldDecorator("ibgGroupId", {
                  initialValue: this.state.cfgOneStep.ibgGroupId,

                  rules: [
                    {
                      required: true,
                      message: "Please Select Inbound Group",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    onChange={(value) => this.handleDropdownChange(value)}
                  >
                    {inboundGroupOptions}
                  </Select>
                )}
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button
                  className="button-submit"
                  type="primary"
                  onClick={this.handleDeactivate}
                  size={"small"}
                  loading={this.state.loading}
                >
                  Deactivate
                </Button>

                <Button
                  className="button-activate"
                  type="primary"
                  onClick={this.handleConfirm}
                  size={"small"}
                  loading={this.state.loading}
                >
                  Save & Activate
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
      </Page>
    );
  }
}

export default Form.create()(withSharedStateConsumer(OneStepCallFlow));
